<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="4"
                lg="6"
                md="6"
                sm="4"
            >
                <h3>Supervisor Dashboard</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                cols="12"
                lg="4"
                md="12"
                sm="12"
            >
                <label>Profile</label>
                <v-combobox
                    v-model="filter.profileSelected"
                    :items="listProfile"
                    item-text="name"
                    item-value="id"
                    clearable
                    single-line
                    outlined
                    @change="filter.userResponsibleSelected = null"
                    dense
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="4"
                md="12"
                sm="12"
            >
                <label>User</label>
                <v-combobox
                    v-model="filter.userResponsibleSelected"
                    :items="listUser"
                    item-text="name"
                    item-value="id"
                    clearable
                    single-line
                    outlined
                    dense
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="4"
                md="12"
                sm="12"
            >
                <label>Supervisor</label>
                <v-combobox
                    :items="listSupervisors"
                    item-text="name"
                    item-value="id"
                    multiple
                    clearable
                    single-line
                    outlined
                    dense
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="4"
                md="4"
                sm="12"
            >
                <label>Status</label>
                <v-combobox
                    v-model="filter.statusSelected"
                    :items="listStatus" 
                    item-text="statusDescription"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="2"
                sm="12"
            >
                <label>Type of work</label>
                <v-combobox
                    v-model="filter.typeWorkSelected"
                    :items="listTypeWork" 
                    item-text="kindWorkDescription"
                    item-value="id"
                    clearable
                    outlined
                    dense
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="2"
                sm="12"
            >
                <v-menu
                    ref="mnuStartDate"
                    v-model="mnuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Start Date</label>
                        <v-text-field
                            v-model="filter.startDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.startDate"
                        no-title
                        @input="mnuStartDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="2"
                sm="12"
            >
                <v-menu
                    ref="mnuEndDate"
                    v-model="filter.mnuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>End Date</label>
                        <v-text-field
                            v-model="filter.endDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.endDate"
                        no-title
                        @input="mnuEndDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col 
                style="text-align: center; margin-top: 22px;"
                cols="12"
                lg="2"
                md="2"
                sm="8"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                            class="v-btn-large"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row style="margin-bottom: 30px !important;">
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <strong>Legend</strong>
                <v-row style="height: 50px !important;">
                    <v-col
                        cols="12"
                        lg="10"
                        md="8"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkClearSelectAll"
                            label="Clear / Select All"
                            :value="true"
                            @change="clearSelectAll()"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row class="rowLegend">
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkJobs"
                            label="Jobs"
                            color="var(--color__blue) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkWorkOrder"
                            label="Work Order"
                            color="var(--color__work_order) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>

                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkInspection"
                            label="Inspection"
                            color="var(--color__inspection) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row class="rowLegend">
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionPreDig"
                            label="Construction - Pre-Dig"
                            color="var(--color__construction_dashboard_predig) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionFrontEnd"
                            label="Construction - Front End"
                            color="var(--color__construction_dashboard_frontend) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionGradingPlumbing"
                            label="Construction - Grading / Plumbing"
                            color="var(--color__construction_dashboard_grading_plumbing) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row class="rowLegend">
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionTileDeck"
                            label="Construction - Tile / Deck"
                            color="var(--color__construction_dashboard_tiledeck) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionEquipmentElectric"
                            label="Construction - Equipment / Electric"
                            color="var(--color__construction_dashboard_equipment_electric) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionPrepPlaster"
                            label="Construction - Prep / Plaster"
                            color="var(--color__construction_dashboard_prep_plaster) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row class="rowLegend">
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionFence"
                            label="Construction - Fence"
                            color="var(--color__construction_dashboard_fence) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionBBQ"
                            label="Construction - BBQ"
                            color="var(--color__construction_dashboard_bbq) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                    >
                        <v-checkbox
                            v-model="chkConstructionPergola"
                            label="Construction - Outdoor"
                            color="var(--color__construction_dashboard_pergola) !important"
                            :value="true"
                            @change="getRegisters()"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-card
                    flat
                    tile
                >
                    <!-- SUPERVISOR -->
                    <v-card class="margin-card frontdesk_alpha">
                        <v-card-title class="text-h6 frontdesk d-flex justify-space-between">
                            
                            <div>
                                <v-icon left class="pipelineIconTitle">mdi mdi-account-tie</v-icon>
                                <label class="pipelineLabelTitle">Detailed</label>
                            </div>

                        </v-card-title> 
                        <v-card-text 
                            class="pipelineDetails"
                        >
                            <v-row>
                                <v-col 
                                    cols="12"
                                    lg="12"
                                    md="12"
                                    sm="12"
                                >
                                    <v-data-table
                                        :headers="headers"
                                        :items="listJobsBySupervisor"
                                        :options.sync="options"
                                        :loading="loading"
                                        :items-per-page="30"
                                        no-data-text="No Record Found"
                                        :single-expand="true"
                                        show-expand
                                        @click:row="showDetails"
                                    >                                    
                                        <template v-slot:expanded-item="{ headers, item }">
                                            <td :colspan="headers.length">
                                                <h3 style="margin-top: 10px;">Details</h3>
                                                <table cellspacing="10" style="width: 90%; border: none; margin: 15px;">
                                                    <thead style="text-align: left;">
                                                        <tr>
                                                            <th>Type</th>
                                                            <th>Job Id</th>
                                                            <th>Contract Date</th>
                                                            <th>Homeowner</th>
                                                            <th>City</th>
                                                            <th>Address</th>
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style="padding: 10px;">
                                                        <tr v-for="(itemDetail, index) in item.listDetails" :key="index">
                                                            <td>{{ itemDetail.type }}</td>
                                                            <td>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }">
                                                                        <a @click="goToDetails(itemDetail)" v-on="on" target="_blank">
                                                                            {{ itemDetail.jobIdFormatted }}
                                                                        </a>
                                                                    </template>
                                                                    <span>{{ itemDetail.type }} Details</span>
                                                                </v-tooltip>
                                                            </td>
                                                            <td>{{ itemDetail.contractDateFormatted }}</td>
                                                            <td>{{ itemDetail.customerName }}</td>
                                                            <td>{{ itemDetail.customerCity }}</td>
                                                            <td>{{ itemDetail.customerAddress }}</td>
                                                            <td>{{ itemDetail.valueFormatted }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </template>

                                        <template
                                            v-slot:footer
                                        >
                                            <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                                <tbody style="padding: 10px;">
                                                    <tr>
                                                        <td style="width: 270px; font-size: 25px; font-weight: bold;">Total</td>
                                                        <td style="width: 250px;">
                                                            <v-chip dark>{{ totals.totalValue }}</v-chip>
                                                        </td>
                                                        <td >
                                                            <v-chip dark>{{ totals.totalQty }}</v-chip>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>

                                    </v-data-table>
                                
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>

                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-card
                    class="d-flex flex-wrap mb-6"
                    flat
                    tile
                >
                    <!-- BY VALUE -->
                    <v-card :width="$vuetify.breakpoint.mobile ? '100%': '48%'" class="margin-card frontdesk_alpha">
                        <v-card-title class="text-h6 frontdesk d-flex justify-space-between">
                            
                            <div>
                                <v-icon left class="pipelineIconTitle">mdi mdi-account-tie</v-icon>
                                <label class="pipelineLabelTitle">By Value</label>
                            </div>

                            <div style="text-align: right;">
                                <label class="labelHoldResumeValue"> {{ totals.totalValue }} </label>
                                <label class="labelHoldResume">Total</label>
                            </div>

                        </v-card-title> 
                        <v-card-text 
                            class="pipelineDetails"
                        >
                            <v-row>
                                <v-col 
                                    cols="12"
                                    lg="6"
                                    md="12"
                                    sm="12"
                                >
                                    <v-row 
                                        v-for="(item, index) in listJobsBySupervisor" :key="index"
                                    >
                                        <v-col 
                                            cols="4"
                                            lg="4"
                                            md="4"
                                            sm="2"
                                            class="alignValue"
                                        >
                                            <label class="pipelineLabelValue">{{ item.valueFormatted }} </label>
                                        </v-col>
                                        <v-col 
                                            cols="6"
                                            lg="5"
                                            md="8"
                                            sm="6"
                                            class="alignValueLabel"
                                        >
                                            <label class="pipelineLabel">{{ item.supervisorName }}</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    lg="6"
                                    md="12"
                                    sm="12"
                                >
                                    <DoughnutChart
                                        :chartId="'dashboardTotalValue'"
                                        :chartData="dashboardTotalValue"
                                        :chartOptions="{
                                            legend: {
                                                position: 'bottom'
                                            }
                                        }"
                                    />
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>

                    <!-- BY QTY -->
                    <v-card :width="$vuetify.breakpoint.mobile ? '100%': '48%'" class="margin-card frontdesk_alpha">
                        <v-card-title class="text-h6 frontdesk d-flex justify-space-between">
                            
                            <div>
                                <v-icon left class="pipelineIconTitle">mdi mdi-account-tie</v-icon>
                                <label class="pipelineLabelTitle">By Qty</label>
                            </div>

                            <div style="text-align: right;">
                                <label class="labelHoldResumeValue"> {{ totals.totalQty }} </label>
                                <label class="labelHoldResume">Total</label>
                            </div>

                        </v-card-title> 
                        <v-card-text 
                            class="pipelineDetails"
                        >
                            <v-row>
                                <v-col 
                                    cols="12"
                                    lg="7"
                                    md="12"
                                    sm="12"
                                >
                                    <v-row 
                                        v-for="(item, index) in listJobsBySupervisor" :key="index"
                                    >
                                        <v-col 
                                            cols="2"
                                            lg="3"
                                            md="4"
                                            sm="2"
                                            class="alignValue"
                                        >
                                            <label class="pipelineLabelValue">{{ item.qty }} </label>
                                        </v-col>
                                        <v-col 
                                            cols="6"
                                            lg="7"
                                            md="8"
                                            sm="6"
                                            class="alignValueLabel"
                                        >
                                            <label class="pipelineLabel">{{ item.supervisorName }}</label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    lg="5"
                                    md="12"
                                    sm="12"
                                >
                                    <DoughnutChart
                                        :chartId="'dashboardTotalQty'"
                                        :chartData="dashboardTotalQty"
                                        :chartOptions="{
                                            legend: {
                                                position: 'bottom'
                                            }
                                        }"
                                    />
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-card
                    class="margin-card frontdesk_alpha"
                    flat
                    tile
                >
                    <v-card-title class="text-h6 frontdesk d-flex justify-space-between">
                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-map-marker</v-icon>
                            <label class="pipelineLabelTitle">Supervisor Location</label>
                        </div>
                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <div style="width: 100%; height: 80vh" id="mapSupervisorPerformance"></div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import DoughnutChart from '@/components/Graphics/Doughnut.vue';
    import { formaterDecimalBR } from '@/utilities/Utils';
    import { orderBy } from '@/utilities/Utils';
    import * as moment from 'moment';
    import { PROJECT_STATUS } from "@/utilities/Enums";
    export default ({

        mixins: [Helpers],

        components: {
            DoughnutChart
        },
        
        data: () => ({

            graphBorderColor: 'rgb(255, 255, 255, 0.3)',
            defaultColor: 182,

            headers: [
                { text: "Name", value: "supervisorName", sortable: true, width: '250px' },
                { text: "Jobs Total Value", value: "valueFormatted", sortable: true, width: '250px' },
                { text: "Jobs Qty", value: "qty", sortable: true, width: '250px' },
                { text: "Jobs On Hold", value: "qtyOnHold", sortable: true },
                { text: "Complex Jobs Qty", value: "qtyComplexity", sortable: true },
                { text: "Work Orders Qty", value: "qtyWorkOrders", sortable: true },
                { text: "Inpections Qty", value: "qtyInspections", sortable: true }
            ],

            filter: {
                idProfile: null,
                idUser: null,
                supervisorSelected: null,
                profileSelected: null,
                userResponsibleSelected: null,
                typeWorkSelected: null,
                statusSelected: null,
                startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
                startDateFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
                endDateFormatted: moment().clone().endOf('month').format('MM/DD/YYYY')
            },

            chkClearSelectAll: true,
            chkJobs: true,
            chkConstructionPreDig: true,
            chkConstructionFrontEnd: true,
            chkConstructionGradingPlumbing: true,
            chkConstructionTileDeck: true,
            chkConstructionEquipmentElectric: true,
            chkConstructionPrepPlaster: true,
            chkConstructionFence: true,
            chkConstructionBBQ: true,
            chkConstructionPergola: true,
            chkWorkOrder: true,
            chkInspection: true,
            
            mnuStartDate: false,
            mnuEndDate: false,

            listProfile: [],
            listUser: [],
            listSupervisors: [],
            listJobsBySupervisor: [],
            listTypeWork: [],
            listStatus: [],

            totalComplexityQty: 28,
            totalWorkOrdersQty: 15,
            totalInspectionsQty: 11,

			dashboardTotalValue: {
                labels: [],
                datasets: []
            },
            
			dashboardTotalQty: {
                labels: [],
                datasets: []
            },
            
            map: null,

            loading: false,
            options: { rowsPerPage: 30, page: 1 },

            PROJECT_STATUS                
        }),

        watch: {
            "filter.startDate" () {
                this.filter.startDateFormatted = this.formatDate(this.filter.startDate)
                this.getRegisters();
            },

            "filter.endDate" () {
                this.filter.endDateFormatted = this.formatDate(this.filter.endDate)
                this.getRegisters();
            },
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            totals() {
                let totalQty = 0;
                let totalValue = 0;

                if (this.listJobsBySupervisor != null && this.listJobsBySupervisor != undefined) {
                    this.listJobsBySupervisor.forEach(item => {
                        totalQty += item.qty;
                        totalValue += parseFloat(item.value);
                    })
                }

                return {
                    totalQty,
                    totalValue: `$ ${formaterDecimalBR(totalValue.toFixed(2))}`
                }
            }
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            backgroundColors(data, baseColor) {
                const baseHue = baseColor; // Valor de matiz para vermelho
                const saturation = '100%'; // Saturação constante
                const lightnessStep = 10; // Incremento para variar a luminosidade
                const numOfColors = data.length; // Número de cores a serem geradas

                let colors = [];

                for (let i = 0; i < numOfColors; i++) {
                    let lightness = `${i * lightnessStep}%`;
                    let color = `hsl(${baseHue}, ${saturation}, ${lightness})`;
                    colors.push(color);
                }

                return colors;
            },

            async getLists() {
                const listUserResponse = await this.$store.dispatch("userModule/List");
                this.listSupervisors = listUserResponse.filter(usr => usr.constructionSupervisor == 1);
                const listTypeWork = await this.$store.dispatch("serviceModule/ListTypeOfWorks");
                this.listTypeWork = listTypeWork.filter(typ => typ.id >= 1 && typ.id <= 3);
                const listStatus = await this.$store.dispatch("serviceModule/ListStatus");
                this.listStatus = listStatus.filter(sts => sts.id >= 3 && sts.id <= 75 && [4, 13].includes(sts.id) == false).sort((a, b) => { return orderBy(a, b, 0, 'id') });
                await this.loadProfilesAndUsers();
                await this.addFirstItemList();
            },
            
            async loadProfilesAndUsers() {
                
                this.listProfile = await this.$store.dispatch("profileModule/List");
                let listUser = await this.$store.dispatch("userModule/List");
                let idProfileSelected = 0;

                if (this.filter.profileSelected != null && 
                    this.filter.profileSelected != undefined && 
                    this.filter.profileSelected.id != 0) {
                    idProfileSelected = this.filter.profileSelected.id;

                    listUser = listUser.filter(usr => usr.idProfile == idProfileSelected);
                }

                this.listUser = [...listUser];

                if (this.userLoggedGetters.listIDUsers != null && 
                    this.userLoggedGetters.listIDUsers != undefined &&
                    this.userLoggedGetters.listIDUsers.toString().trim() != '') {
                    const listIDUsers = this.userLoggedGetters.listIDUsers.toString().split(';');

                    let newListUsers = [];

                    listIDUsers.forEach(idUser => {

                        if (idUser != null && idUser != undefined && idUser.toString().trim() != '') {
                            const userFiltered = listUser.filter(item => item.id.toString() == idUser)[0];

                            if (userFiltered && userFiltered != null && userFiltered != undefined) {
                                newListUsers.push(userFiltered);
                                this.listUser = newListUsers;
                            }
                        }
                    });
                }
            },

            async addFirstItemList() {

                const itemAllProfiles = {
                    id: 0,
                    name: 'All Profiles'
                }

                const itemAllUsers = {
                    id: 0,
                    name: `All Users`
                }

                const itemAllTypeOfWorks = {
                    id: 0,
                    kindWorkDescription: `All Type Of Works`
                }

                const itemAllStatus = {
                    id: -1,
                    statusDescription: `All Status`
                }

                this.listProfile.unshift(itemAllProfiles)

                this.listUser.unshift(itemAllUsers)

                if (this.filter.profileSelected == null || this.filter.profileSelected == undefined) {
                    this.filter.profileSelected = itemAllProfiles;
                }

                if (this.filter.userResponsibleSelected == null || this.filter.userResponsibleSelected == undefined) {
                    this.filter.userResponsibleSelected = itemAllUsers;
                }

                if (this.filter.typeWorkSelected == null || this.filter.typeWorkSelected == undefined) {
                    this.filter.typeWorkSelected = itemAllTypeOfWorks;
                }

                if (this.filter.statusSelected == null || this.filter.statusSelected == undefined) {
                    this.filter.statusSelected = itemAllStatus;
                }
            },

            async loadTotalValue() {
                const dataTotalValue = this.listJobsBySupervisor;
                const labels = dataTotalValue.map( (item) => item.supervisorName )
                const data = dataTotalValue.map( (item) => item.value )

                this.dashboardTotalValue = {
                    labels,
                    datasets: [
                        {
                            backgroundColor: this.backgroundColors(data, this.defaultColor),
                            borderColor: this.graphBorderColor,
                            data
                        }
                    ]
                }
            },

            async loadTotalQty() {
                const dataTotalQty = this.listJobsBySupervisor;
                const labels = dataTotalQty.map( (item) => item.supervisorName )
                const data = dataTotalQty.map( (item) => item.qty )

                this.dashboardTotalQty = {
                    labels,
                    datasets: [
                        {
                            backgroundColor: this.backgroundColors(data, this.defaultColor),
                            borderColor: this.graphBorderColor,
                            data
                        }
                    ]
                }
            },

            getFilterRequest() {

                let idProfile = 0;
                let idUser = 0;
                let listIDSupervisor = '';
                let status = -1;
                let idKindWork = 0;
                
                if (this.filter.profileSelected != null && this.filter.profileSelected != undefined) {
                    idProfile = this.filter.profileSelected.id
                }

                if (this.filter.userResponsibleSelected != null && this.filter.userResponsibleSelected != undefined) {
                    idUser = this.filter.userResponsibleSelected.id
                }

                if (this.filter.supervisorSelected != null && this.filter.supervisorSelected != undefined) {
                    listIDSupervisor = this.filter.supervisorSelected.join(',');
                }

                if (this.filter.statusSelected != null && this.filter.statusSelected != undefined) {
                    status = this.filter.statusSelected.id;
                }

                if (this.filter.typeWorkSelected != null && this.filter.typeWorkSelected != undefined) {
                    idKindWork = this.filter.typeWorkSelected.id;
                }

                const startDate = this.filter.startDate;
                const endDate = this.filter.endDate;

                console.log('this.chkWorkOrder', this.chkWorkOrder);
                
                const request = {
                    idProfile,
                    idUser,
                    listIDSupervisor,
                    status,
                    idKindWork,
                    startDate,
                    endDate,
                    chkJobs: this.chkJobs == null ? false : this.chkJobs,      
                    chkConstructionPreDig: this.chkConstructionPreDig == null ? false : this.chkConstructionPreDig,
                    chkConstructionFrontEnd: this.chkConstructionFrontEnd == null ? false : this.chkConstructionFrontEnd,
                    chkConstructionGradingPlumbing: this.chkConstructionGradingPlumbing == null ? false : this.chkConstructionGradingPlumbing,
                    chkConstructionTileDeck: this.chkConstructionTileDeck == null ? false : this.chkConstructionTileDeck,
                    chkConstructionEquipmentElectric: this.chkConstructionEquipmentElectric == null ? false : this.chkConstructionEquipmentElectric,
                    chkConstructionPrepPlaster: this.chkConstructionPrepPlaster == null ? false : this.chkConstructionPrepPlaster,
                    chkConstructionFence: this.chkConstructionFence == null ? false : this.chkConstructionFence,
                    chkConstructionBBQ: this.chkConstructionBBQ == null ? false : this.chkConstructionBBQ,
                    chkConstructionPergola: this.chkConstructionPergola == null ? false : this.chkConstructionPergola,
                    chkWorkOrder: this.chkWorkOrder == null ? false : this.chkWorkOrder,
                    chkInspection: this.chkInspection == null ? false : this.chkInspection
                }

                return request;
            },
            
            async getRegisters() {
                this.showLoading();
                this.listJobsBySupervisor = await this.$store.dispatch("reportModule/SupervisorPerformance", this.getFilterRequest());                
                this.savePreferences();
                
                this.loadTotalValue();
                this.loadTotalQty();

                await this.updateMap();

                this.hideLoading();
            },

            showDetails(_, item2) {
                item2.expand(!item2.isExpanded);
            },

            goToDetails(itemDetail) {

                const routeName = itemDetail.type == 'Job' ? 'serviceDetails' : (itemDetail.type == 'Work Order' ? 'workOrderForm' : 'inspectionForm');

                this.$router.push({ name: routeName, params: {id: itemDetail.jobId} });
            },

            async updateMap() {

                if (this.listJobsBySupervisor != null && this.listJobsBySupervisor.length > 0) {

                    if (this.map != null) {
                        this.map.remove();
                        this.map = null;
                    }

                    const L = window.L; // Garante que Leaflet está disponível

                    // Verifica se o elemento existe antes de iniciar o mapa
                    if (document.getElementById("mapSupervisorPerformance") && 
                        this.listJobsBySupervisor[0].listDetails != null &&
                        this.listJobsBySupervisor[0].listDetails.length > 0
                    ) {
                        this.map = L.map("mapSupervisorPerformance").setView(
                            [this.listJobsBySupervisor[0].listDetails[0].latitude, this.listJobsBySupervisor[0].listDetails[0].longitude], 
                            11
                        );

                        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                            attribution: '&copy; OpenStreetMap contributors'
                        }).addTo(this.map);

                        // Adiciona todos os marcadores
                        this.listJobsBySupervisor.forEach(job => {
                            job.listDetails.forEach(adr => {

                                const html = `<b><a style='font-size: 14px;' id="link-${adr.id}">${adr.type}: ${adr.jobIdFormatted}</a></b><br/><br/>
                                              <b>Supervisor</b>: ${job.supervisorName}<br/>
                                              <b>Address</b>: ${adr.customerFullAddress}<br/>
                                              <b>Value</b>: ${adr.valueFormatted}<br/>
                                              <b>Status</b>: ${adr.statusProjectDescription}`;

                                const marker = L.marker([adr.latitude, adr.longitude]).addTo(this.map)
                                    .bindPopup(html);
                                    
                                marker.on("popupopen", () => {
                                    document
                                        .getElementById(`link-${adr.id}`)
                                        .addEventListener("click", () => this.goToDetails(adr));
                                });
                            });
                        });
                    }
                }
            },

            clearSelectAll() {
                
                this.chkJobs = this.chkClearSelectAll;
                this.chkConstructionPreDig = this.chkClearSelectAll;
                this.chkConstructionFrontEnd = this.chkClearSelectAll;
                this.chkConstructionGradingPlumbing = this.chkClearSelectAll;
                this.chkConstructionTileDeck = this.chkClearSelectAll;
                this.chkConstructionEquipmentElectric = this.chkClearSelectAll;
                this.chkConstructionPrepPlaster = this.chkClearSelectAll;
                this.chkConstructionFence = this.chkClearSelectAll;
                this.chkConstructionBBQ = this.chkClearSelectAll;
                this.chkConstructionPergola = this.chkClearSelectAll;
                this.chkWorkOrder = this.chkClearSelectAll;
                this.chkInspection = this.chkClearSelectAll;

                this.getRegisters();
            },

            async savePreferences() {

                const preferences = {
                    filter: this.filter,
                    chkJobs: this.chkJobs,
                    chkConstructionPreDig: this.chkConstructionPreDig,
                    chkConstructionFrontEnd: this.chkConstructionFrontEnd,
                    chkConstructionGradingPlumbing: this.chkConstructionGradingPlumbing,
                    chkConstructionTileDeck: this.chkConstructionTileDeck,
                    chkConstructionEquipmentElectric: this.chkConstructionEquipmentElectric,
                    chkConstructionPrepPlaster: this.chkConstructionPrepPlaster,
                    chkConstructionFence: this.chkConstructionFence,
                    chkConstructionBBQ: this.chkConstructionBBQ,
                    chkConstructionPergola: this.chkConstructionPergola,
                    chkWorkOrder: this.chkWorkOrder,
                    chkInspection: this.chkInspection
                };

                localStorage.setItem('dashSupPerfPreferences', JSON.stringify(preferences));
            },

            async getPreferences() {

                const jsonPreferences = localStorage.getItem('dashSupPerfPreferences');

                if (jsonPreferences != null && jsonPreferences != undefined) {
                    const preferences = JSON.parse(jsonPreferences);

                    if (preferences != null && preferences != undefined) {
                        this.filter.profileSelected = preferences.filter.profileSelected;
                        this.filter.userResponsibleSelected = preferences.filter.userResponsibleSelected;
                        this.chkJobs = preferences.chkJobs;
                        this.chkConstructionPreDig = preferences.chkConstructionPreDig;
                        this.chkConstructionFrontEnd = preferences.chkConstructionFrontEnd;
                        this.chkConstructionGradingPlumbing = preferences.chkConstructionGradingPlumbing;
                        this.chkConstructionTileDeck = preferences.chkConstructionTileDeck;
                        this.chkConstructionEquipmentElectric = preferences.chkConstructionEquipmentElectric;
                        this.chkConstructionPrepPlaster = preferences.chkConstructionPrepPlaster;
                        this.chkConstructionFence = preferences.chkConstructionFence;
                        this.chkConstructionBBQ = preferences.chkConstructionBBQ;
                        this.chkConstructionPergola = preferences.chkConstructionPergola;
                        this.chkWorkOrder = preferences.chkWorkOrder;
                        this.chkInspection = preferences.chkInspection;
                    }
                }
            }
        },

        async created() {
            this.showLoading();
            try {
                await this.getPreferences();
            } catch (error) {
                console.error("Error to get preferences:", error);
            }
            await this.getLists();
            await this.getRegisters();
            this.hideLoading();
        },
    })
</script>

<style scoped>

    label {
        font-size: 14px !important;
        color: #5e5e5e;
    }

    .pipelineDetails {
        margin-top: 15px;
    }

    .pipelineIconTitle {
        color: white !important;
    }

    .pipelineLabelTitle {
        color: white !important;
        font-size: 17px;
    }

    .labelHoldResume {
        color: rgb(255, 255, 255, 0.8) !important;
        font-size: 17px;
    }

    .labelHoldResumeValue {
        color: white !important;
        font-size: 17px !important;
        margin-right: 5px;
    }

    .pipelineLabel {
        font-size: 17px;
    }

    .pipelineLabelValue {
        color: var(--color__main) !important;
        font-weight: bold !important; 
        font-size: 20px !important;
    }

    .pipelineLabelRedValue {
        color: var(--color__preDig_alert) !important;
        font-weight: bold !important; 
        font-size: 20px !important;
    }

    .pipelineLabelValueBlank {
        color: transparent !important;
        font-weight: bold !important; 
        font-size: 20px !important;
    }

    .alignValue {
        margin-left: 15px;
        text-align: center;
    }

    .alignValueLabel {
        margin-left: 35px;
    }

    .frontdesk {
        background-color: var(--color__construction_dashboard_predig);
    }

    .frontdesk_alpha {
        background-color: var(--color__construction_dashboard_predig_alpha);
    }

    .leads {
        background-color: var(--color__construction_dashboard_frontend);
    }

    .leads_alpha {
        background-color: var(--color__construction_dashboard_frontend_alpha);
    }

    .sales {
        background-color: var(--color__construction_dashboard_grading_plumbing);
    }

    .sales_alpha {
        background-color: var(--color__construction_dashboard_grading_plumbing_alpha);
    }

    .drafting {
        background-color: var(--color__construction_dashboard_tiledeck);
    }

    .drafting_alpha {
        background-color: var(--color__construction_dashboard_tiledeck_alpha);
    }

    .permitting {
        background-color: var(--color__construction_dashboard_equipment_electric);
    }

    .permitting_alpha {
        background-color: var(--color__construction_dashboard_equipment_electric_alpha);
    }

    .construction {
        background-color: var(--color__construction_dashboard_prep_plaster);
    }

    .construction_alpha {
        background-color: var(--color__construction_dashboard_prep_plaster_alpha);
    }

    .service {
        background-color: var(--color__construction_dashboard_fence);
    }

    .service_alpha {
        background-color: var(--color__construction_dashboard_fence_alpha);
    }

    .inspections {
        background-color: var(--color__construction_dashboard_inspections);
    }

    .inspections_alpha {
        background-color: var(--color__construction_dashboard_inspections_alpha);
    }

    .work_order {
        background-color: var(--color__construction_dashboard_work_order);
    }

    .work_order_alpha {
        background-color: var(--color__construction_dashboard_work_order_alpha);
    }

    .margin-card {
        margin: 10px;
    }

    div[class^='col-'] {
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>

<style>

    table > tbody > tr {
        cursor: pointer !important;
    }

</style>